import { Exclude, Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { AccAttachmentRawDto } from '../../shared-acc-board-approval-module/_models/acc-attachment-raw-dto';

export class AccItemRawDto {
    accItemId: number;
    categoryId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    description: string;
    statusId: number;

    responseToOwner: string;
    allowanceCategoryId: string;
    allowanceSubCategoryId: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    allowanceStartDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    allowanceEndDate: Date;

    depositTypeId: number;
    depositStatusId: number;
    depositRef: string;
    depositAmount: number;
    finalized: boolean;
    crudAction: string;

    @Type(() => AccAttachmentRawDto)
    itemAttachments: AccAttachmentRawDto[] = [];

    daysRemaining: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    committeeSubmittedDate: Date;

    hasNotes: boolean;

    // Transient Variable
    @Exclude()
    id: number;
}
